import { FontFamily } from 'database'
import {
  ABeeZee,
  Barlow_Condensed,
  IBM_Plex_Sans_Condensed,
  Playfair_Display,
  Roboto,
  Roboto_Condensed,
  Roboto_Mono,
  Space_Grotesk,
  Space_Mono,
} from 'next/font/google'
import localFont from 'next/font/local'

type NextFont = ReturnType<typeof ABeeZee>

const barlow_condensed = Barlow_Condensed({
  weight: '400',
  subsets: ['latin'],
})

const ibm_plex_sans_condensed = IBM_Plex_Sans_Condensed({
  weight: '400',
  subsets: ['latin'],
})

const playfair_display = Playfair_Display({
  weight: '400',
  subsets: ['latin'],
})

const roboto = Roboto({
  weight: '400',
  subsets: ['latin'],
})

const roboto_condensed = Roboto_Condensed({
  weight: '400',
  subsets: ['latin'],
})

const roboto_mono = Roboto_Mono({
  weight: '400',
  subsets: ['latin'],
})

const space_grotesk = Space_Grotesk({
  weight: '400',
  subsets: ['latin'],
})

const space_mono = Space_Mono({
  weight: '400',
  subsets: ['latin'],
})

const helvetica = localFont({
  src: '../fonts/Helvetica.woff2',
})

export const documentFonts = {
  barlow_condensed,
  ibm_plex_sans_condensed,
  playfair_display,
  roboto,
  roboto_condensed,
  roboto_mono,
  space_grotesk,
  space_mono,
  helvetica,
} satisfies Record<FontFamily, NextFont>
